import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { SubmissionsAggregate } from "./types";

// GET /api/admin/submissions/aggregate — top-line counts for the queue
// page's 4 metric cards. Invalidated by accept + decline mutation hooks.
export function useSubmissionsAggregate() {
  return useQuery<SubmissionsAggregate, ApiClientError>({
    queryKey: queryKeys.submissions.aggregate(),
    queryFn: () =>
      apiFetch<SubmissionsAggregate>(`/admin/submissions/aggregate`),
  });
}
